import React from "react";
import DashboardWelcomeSection from "./DashboardWelcomeSection";
import MyActionsIntro from "../Action/MyActionsIntro";

const MySpace = ({ onGoToActionPlan }) => {
  return (
    <div className="w-full min-h-full flex flex-col items-stretch justify-start">
      <div className="w-full max-w-full">
        <DashboardWelcomeSection />
      </div>

      <div className="w-full mt-6">
        <MyActionsIntro onGoToActionPlan={onGoToActionPlan} />
      </div>
    </div>
  );
};

export default MySpace;